/* eslint-disable */

export enum ActionType {
  ACTION_TYPE_UNSPECIFIED = "ACTION_TYPE_UNSPECIFIED",
  ACTION_TYPE_LOGIN_ATTEMPT = "ACTION_TYPE_LOGIN_ATTEMPT",
}

export interface CreateMoonsenseBundleRequest {
  moonsense_journey_id?: string;
  cash_flow_token?: string;
  customer_action?: ActionType;
  /** https://docs.moonsense.io/articles/sdk/data-model#Bundle */
  information_captured_as_json?: string;
  session_id?: string;
}

export interface CreateMoonsenseBundleResponse {
}

export interface CaptureThreatmetrixSessionRequest {
  threatmetrix_session_id?: string;
  cash_flow_token?: string;
  customer_action?: ActionType;
}

export interface CaptureThreatmetrixSessionResponse {
}

export interface MoonsenseService {
  CreateMoonsenseBundle(request: CreateMoonsenseBundleRequest): Promise<CreateMoonsenseBundleResponse>;
}

export interface ThreatmetrixService {
  CaptureThreatmetrixSession(request: CaptureThreatmetrixSessionRequest): Promise<CaptureThreatmetrixSessionResponse>;
}
